export default __webpack_public_path__ + "static/media/weather-rain.5882acc8.webp";